import React, { useEffect, useRef, useState } from 'react';

function Team() {
  const team = {
    name: 'Kamble Vishvapratap',
    role: 'Bird Netting Service Specialist',
    email: 'kamblevishvapratap@gmail.com',
    phones: ['+91 8380898245', '+91 9579858376'],
    time: '8:00 AM - 10:00 PM',
    whatsapp: 'https://wa.link/nfcezm',
  };

  const statsData = [
    { label: 'Net Installations', value: 1230 },
    { label: 'Companies Served', value: 115 },
    { label: 'Years Experience', value: 10 },
  ];

  const [stats, setStats] = useState(statsData.map(() => 0));
  const statsRef = useRef(null);

  const easeOut = (t) => 1 - Math.pow(1 - t, 4);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;

        let startTime = null;
        const duration = 1500;

        const animate = (ts) => {
          if (!startTime) startTime = ts;
          const progress = Math.min((ts - startTime) / duration, 1);

          setStats(
            statsData.map((s) => Math.floor(s.value * easeOut(progress)))
          );

          if (progress < 1) requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
        observer.disconnect();
      },
      { threshold: 0.4 }
    );

    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, []);

  const copyNumber = (num) => {
    navigator.clipboard.writeText(num);
    alert('Copied: ' + num);
  };

  return (
    <>
      <section className='team-section container-fluid py-5 w-100'>
        <div className='container px-3 px-md-5'>
          {/* Profile Card */}
          <div className='row justify-content-center'>
            <div className='col-lg-7'>
              <div
                className='team-card text-center p-4 p-md-5 bg-white'
                data-aos='fade-up'
              >
                <h4 className='fw-bold text-primary mb-1'>{team.name}</h4>
                <p className='fw-semibold text-dark mb-3'>{team.role}</p>

                <p className='mb-3 text-dark fw-semibold'>
                  <i className='bi bi-envelope-fill me-2'></i>
                  {team.email}
                </p>

                {team.phones.map((num, i) => (
                  <p className='mb-1 text-dark fw-semibold' key={i}>
                    <i className='bi bi-telephone-fill me-2'></i> {num}
                  </p>
                ))}

                <p className='fw-bold mt-2 text-dark'>Time: {team.time}</p>

                <div className='d-flex justify-content-center gap-2 mt-3'>
                  {team.phones.map((num, i) => (
                    <button
                      key={i}
                      className='btn btn-sm btn-outline-primary rounded-pill fw-semibold'
                      onClick={() => copyNumber(num)}
                    >
                      Copy {i + 1}
                    </button>
                  ))}
                  <a
                    href={team.whatsapp}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='btn btn-sm btn-success rounded-pill fw-semibold'
                  >
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Stats Highlight Band */}
          <div
            ref={statsRef}
            className='row text-center mt-5 py-4 px-2 px-md-5 rounded-4 shadow stats-band'
            data-aos='fade-up'
          >
            {statsData.map((item, i) => (
              <div
                className='col-4'
                key={i}
                data-aos='zoom-in'
                data-aos-delay={i * 180}
              >
                <h3 className='fw-bold text-primary mb-1'>{stats[i]}+</h3>
                <p className='text-dark fw-semibold small mb-0'>{item.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Styling */}
        <style>{`
          .team-section {
            background: #f5f9fc;
          }
          .team-card {
            border: 1px solid rgba(0, 0, 0, 0.06);
            border-radius: 15px;
            box-shadow: 0 5px 22px rgba(0,0,0,0.08) !important;
            transition: .3s ease;
          }
          .team-card:hover {
            transform: translateY(-6px);
            box-shadow: 0 12px 28px rgba(0,0,0,0.12) !important;
          }

          .stats-band {
            background: #e8f2ff;
            border-radius: 18px !important;
            box-shadow: 0 5px 15px rgba(0,0,0,0.08);
          }

          h4 { font-size: 1.45rem; }
          .stats-band h3 { font-size: 1.9rem; }

          @media(max-width: 768px) {
            .stats-band h3 { font-size: 1.5rem }
          }
        `}</style>
      </section>
    </>
  );
}

export default Team;
